/**
 * Shared styles for AI Prescription page
 */

import { getScrollbarSx } from "../../utils/AIPrescription/constants";

/**
 * Outer page container — fills the viewport-locked panel (see useViewportLock).
 * Do not use minHeight: 100vh here; that stacks with the results scroller and
 * creates a second (document) scrollbar.
 */
export const pageContainerStyle = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
  boxSizing: "border-box",
} as const;

/** Results section grows to fill space between tabs and the input-bar spacer. */
export const resultsSectionStyle = {
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
} as const;

/**
 * Sx for the results container Box (conversation list).
 * This is the only scrollport on the AgenticRx page.
 */
export const getResultsContainerSx = (
  primaryColor: string,
  _barOpen: boolean = true
) => ({
  flex: 1,
  minHeight: 0,
  height: "100%",
  overflowY: "auto" as const,
  overflowX: "hidden" as const,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: 1,
  margin: "16px",
  padding: 0,
  borderRadius: 2,
  boxShadow: "0 2px 8px rgba(0,0,0,0.1) !important",
  ...getScrollbarSx(primaryColor),
});
